// // import ReactDOM from "react-dom/client";
// // import { BrowserRouter } from "react-router-dom";
// // import "./index.css";
// // import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// // import App from "./App";
// // const queryClient = new QueryClient({
// //   defaultOptions: {
// //     queries: {
// //       refetchOnWindowFocus: false,
// //     },
// //   },
// // });
// // const root = ReactDOM.createRoot(document.getElementById("root"));

// // root.render(
// //   <BrowserRouter>
// //     <QueryClientProvider client={queryClient}>
// //       <App />
// //     </QueryClientProvider>
// //   </BrowserRouter>
// // );
// import ReactDOM from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import "./index.css";
// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { Provider } from "react-redux"; // Import Provider from react-redux
// import store from "./store/store"; // Import your Redux store
// import "react-toastify/dist/ReactToastify.css";
// import i18n from "./i18n"; // Import i18n configuration

// import { I18nextProvider } from "react-i18next";
// import App from "./App";
// import { ToastContainer } from "react-toastify";
// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       refetchOnWindowFocus: false,
//     },
//   },
// });
// const root = ReactDOM.createRoot(document.getElementById("root"));

// root.render(
//   <Provider store={store}>
//     <BrowserRouter>
//         <QueryClientProvider client={queryClient}>
//       <I18nextProvider i18n={i18n}>
//           <App />
//           <ToastContainer />
//       </I18nextProvider>
//         </QueryClientProvider>
//     </BrowserRouter>
//   </Provider>
// );

import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom";

import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import store from "./store/store";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "react-phone-input-2/lib/style.css";

import { ToastContainer } from "react-toastify";
import "./i18n";
import { SocketProvider } from "config/SocketContext";
import { UserProvider } from "config/selectedUserContext";
import { UseItemList } from "config/itemListContext";
import { UseItemListProvider } from "config/itemListContext";
import { PricesContextProvider } from "config/pricesContext";
import { NotesContextProvider } from "config/Notes";
import { MessageProvider } from "config/MessageProvider";
import { ProfileCTX } from "config/ProfileCTX";
import GoogleTranslateProvider from "config/GoogleTranslateProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ProfileCTX>
          <UseItemListProvider>
            <UserProvider>
              <PricesContextProvider>
                <NotesContextProvider>
                  <SocketProvider>
                    <MessageProvider>
                      <GoogleTranslateProvider>
                        <App />
                      </GoogleTranslateProvider>
                    </MessageProvider>
                  </SocketProvider>
                </NotesContextProvider>
              </PricesContextProvider>
            </UserProvider>
          </UseItemListProvider>
        </ProfileCTX>
        <ToastContainer />
      </QueryClientProvider>
    </BrowserRouter>
  </Provider>
);
// ReactDOM.render(
//   <Provider store={store}>
//     <BrowserRouter>
//       <QueryClientProvider client={queryClient}>
//         <App />
//         <ToastContainer />
//       </QueryClientProvider>
//     </BrowserRouter>
//   </Provider>,
//   document.getElementById("root")
// );
